import { render, staticRenderFns } from "./EditableDocumentList.vue?vue&type=template&id=60964030&scoped=true&"
import script from "./EditableDocumentList.vue?vue&type=script&lang=js&"
export * from "./EditableDocumentList.vue?vue&type=script&lang=js&"
import style0 from "./EditableDocumentList.vue?vue&type=style&index=0&id=60964030&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60964030",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VIcon,VSimpleTable,VSkeletonLoader})
